
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/[pageId]",
      function () {
        return require("private-next-pages/info/[pageId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/[pageId]"])
      });
    }
  